import {
  AccountCircle,
  Add,
  ArrowDropDown,
  Check,
  ChevronLeft,
  ChevronRight,
  Close,
  Colorize,
  Edit,
  EmojiPeople,
  Feedback,
  FileCopy,
  Home,
  InfoOutlined,
  List,
  LocalPharmacy,
  LocalPharmacyOutlined,
  LocationOn,
  Menu,
  Notes,
  PlaylistAdd,
  RecordVoiceOverOutlined,
  Search,
  WarningAmber,
} from '@mui/icons-material';
import { IconPillOff, IconBrandHipchat } from '@tabler/icons-react';

import { ReactComponent as AddEventIcon } from 'src/common/ui/assets/icon-add-event.svg';

export const BoulderIconMap = {
  accountCircle: AccountCircle,
  add: Add,
  addEvent: AddEventIcon,
  arrowDropDown: ArrowDropDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  copy: FileCopy,
  check: Check,
  delete: Close,
  drugScreening: Colorize,
  edit: Edit,
  feedback: Feedback,
  home: Home,
  infoOutlined: InfoOutlined,
  list: List,
  localPharmacy: LocalPharmacy,
  localPharmacyOutlined: LocalPharmacyOutlined,
  location: LocationOn,
  menu: Menu,
  notes: Notes,
  playlistAdd: PlaylistAdd,
  recordVoiceOverOutlined: RecordVoiceOverOutlined,
  rxRunOut: IconPillOff,
  search: Search,
  speechBubble: IconBrandHipchat,
  warning: WarningAmber,
  waving: EmojiPeople,
};

export type BoulderIconName = keyof typeof BoulderIconMap;
